<ag-shr-image-with-loader
  class="profile-picture__image"
  [isRound]="isRound"
  [borderRounded]="!isRound"
  [withBorder]="!isRound"
  [wasabiPath]="headshot?.wasabiPath"
  [cropperPayload]="headshot?.imageCropperPayload"
  [mediaSize]="MediaSize.origin"
  [ngStyle]="
    maintainPreviewAspectRatio && ratio ? { 'aspect-ratio': ratio.w + '/' + ratio.h, 'object-fit': 'fill' } : null
  "
></ag-shr-image-with-loader>

<dx-drop-down-button
  *ngIf="showDropDownMenu && canEdit; else buttonsTemp"
  class="agent-campaign-picture__button"
  [showArrowIcon]="false"
  [dropDownOptions]="{ width: 230 }"
  icon="edit"
  stylingMode="text"
  [disabled]="isReadOnly"
  [agMergeGuard]="agentDbId"
  [items]="dropDownItems"
  [useItemTextAsTitle]="false"
  (onItemClick)="handleDropDownItemClick($event)"
>
</dx-drop-down-button>

<ng-template #buttonsTemp>
  <div class="d-flex flex-column align-items-center ms-1">
    <dx-button
      *ngIf="canEdit"
      class="agent-campaign-picture__button"
      icon="edit"
      stylingMode="text"
      [disabled]="isReadOnly"
      type="default"
      [hint]="headshot?.wasabiPath ? 'Change Picture' : 'Add Picture'"
      [agMergeGuard]="agentDbId"
      (agMergeGuardedClick)="onUploadClicked()"
    ></dx-button>

    <dx-button
      *ngIf="headshot?.wasabiPath && canEdit"
      class="agent-campaign-picture__button"
      icon="agi-crop"
      stylingMode="text"
      [disabled]="isReadOnly"
      type="default"
      [hint]="'Crop Picture'"
      [agMergeGuard]="agentDbId"
      (agMergeGuardedClick)="handleCropImage()"
    ></dx-button>

    <dx-button
      [visible]="headshot?.wasabiPath && canDelete"
      class="agent-campaign-picture__button"
      icon="trash"
      stylingMode="text"
      [disabled]="isReadOnly"
      type="default"
      [hint]="'Delete Picture'"
      [agMergeGuard]="agentDbId"
      (agMergeGuardedClick)="handleDeleteImage()"
    ></dx-button>
  </div>
</ng-template>

<ng-container *ngIf="useCustomMediaUploader; else defaultUploader">
  <ng-container *ngTemplateOutlet="customMediaUploader"></ng-container>
</ng-container>

<ng-template #customMediaUploader>
  <ng-content select="[customMediaUploader]"></ng-content>
</ng-template>

<ng-template #defaultUploader>
  <ag-shr-media-uploader-modal
    [mediaPathPrefix]="mediaPathPrefix"
    (mediaChanged)="onMediaChanged($event)"
    [mediaItems]="mediaItems"
    [mediaSources]="mediaSources"
    [waitForProcessing]="true"
  ></ag-shr-media-uploader-modal>
</ng-template>

<ag-shr-image-cropper-modal
  [roundCropper]="isRound"
  [maintainAspectRatio]="maintainAspectRatio"
  [ratio]="ratio"
  [onImageCropped]="handleImageCropped"
  [title]="'Edit Thumbnail'"
  [isLoading]="isPreparingCropperSig()"
></ag-shr-image-cropper-modal>
